// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7c77069b","455":"91ce2c14","977":"aee6e2ad"}[chunkId] + ".chunk.js";
};